import React from 'react'

const Door = ({ children, delay, isFirst, color }) => (
  <div className={`section door ${isFirst ? 'animate' : ''}`} style={{transitionDelay: `${delay + 1}s`}}>
    <div className='wall wall--left'>
      <div className='door-side door-side--left' />
    </div>
    <div className='door-container'>
      <div className='door-element' />
    </div>
    <div className='wall wall--right'>
      <div className='door-side door-side--right' />
    </div>
    { isFirst ? children : <div className='section' /> }
  </div>
)

export default Door



// WEBPACK FOOTER //
// ./src/components/Door.js